import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { StepperComponent } from './common/layout/stepper/stepper.component';
import { FormInputTextComponent } from './forms/form-input-text/form-input-text.component';
import { FormInputCheckboxComponent } from './forms/form-input-checkbox/form-input-checkbox.component';
import { FormInputDropdownComponent } from './forms/form-input-dropdown/form-input-dropdown.component';
import { FormButtonSubmitComponent } from './forms/form-button-submit/form-button-submit.component';
import { FormInputFileComponent } from './forms/form-input-file/form-input-file.component';
import { FormInputFileListComponent } from './forms/form-input-file/form-input-file-list/form-input-file-list.component';
import { DisputeBoxComponent } from './common/forms/dispute-box/dispute-box.component';
import { SpinnerComponent } from './common/layout/spinner/spinner.component';
import { ThankYouCommonComponent } from './common/thank-you/thank-you-common/thank-you-common.component';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { FormInputDateComponent } from './forms/form-input-date/form-input-date.component';
import { FormInputCurrencyComponent } from './forms/form-input-currency/form-input-currency.component';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgxFileDropModule } from 'ngx-file-drop';
import { TrustpilotWideComponent } from './common/layout/trustpilot-wide/trustpilot-wide.component';
import { FooterComponent } from './common/layout/footer/footer.component';

@NgModule({
  declarations: [
    StepperComponent,
    FormInputTextComponent,
    FormInputCheckboxComponent,
    FormInputDropdownComponent,
    FormButtonSubmitComponent,
    FormInputFileComponent,
    FormInputFileListComponent,
    DisputeBoxComponent,
    SpinnerComponent,
    ThankYouCommonComponent,
    FormInputDateComponent,
    FormInputCurrencyComponent,
    TrustpilotWideComponent,
    FooterComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TranslateModule,
    BsDatepickerModule,
    AccordionModule,
    TooltipModule,
    NgxFileDropModule
  ],
  exports: [
    StepperComponent,
    FormInputTextComponent,
    FormInputCheckboxComponent,
    FormInputDropdownComponent,
    FormButtonSubmitComponent,
    FormInputFileComponent,
    FormInputFileListComponent,
    DisputeBoxComponent,
    SpinnerComponent,
    ThankYouCommonComponent,
    FormInputDateComponent,
    FormInputCurrencyComponent,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    BsDatepickerModule,
    AccordionModule,
    TooltipModule,
    NgxFileDropModule,
    TrustpilotWideComponent,
    FooterComponent
  ]
})
export class SharedModule { } 